import { Form } from "react-bootstrap";
import styled from "styled-components";

export const LabelTabContainer = styled(Form.Label)`
    margin-bottom: 0rem;
`